import { useEffect, useState } from "react";

const SEEN_KEY = "ws_welcome_shown";

// Decide once per page load, memoised at module scope so React 18 StrictMode's
// dev double-mount can't swallow it. Shows once per browser session.
let _decided = false;
let _show = false;
const decideOnce = () => {
  if (_decided) return _show;
  _decided = true;
  try {
    _show = sessionStorage.getItem(SEEN_KEY) !== "1";
    if (_show) sessionStorage.setItem(SEEN_KEY, "1");
  } catch { _show = true; }
  return _show;
};

// Small, non-blocking "developed by" toast at the bottom; auto-hides in ~2s.
export const WelcomeSplash = () => {
  const [show, setShow] = useState(decideOnce);
  const [enter, setEnter] = useState(false);

  useEffect(() => {
    if (!show) return;
    const a = setTimeout(() => setEnter(true), 30);      // slide in
    const b = setTimeout(() => setEnter(false), 2000);   // start fade out at ~2s
    const c = setTimeout(() => setShow(false), 2450);    // unmount
    return () => { clearTimeout(a); clearTimeout(b); clearTimeout(c); };
  }, [show]);

  if (!show) return null;

  return (
    <div
      data-testid="welcome-splash"
      className={`fixed bottom-5 left-1/2 z-[9999] -translate-x-1/2 transition-[opacity,transform] duration-500 ${enter ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"}`}
    >
      <div className="flex max-w-[calc(100vw-16px)] items-center gap-2.5 rounded-full border border-white/10 bg-[#0b0d10]/95 py-1.5 pl-1.5 pr-3.5 shadow-xl backdrop-blur">
        <img
          src="/whitestone-tech.jpg"
          alt="Whitestone Defence and Technology"
          className="h-6 w-6 shrink-0 rounded-full object-cover ring-1 ring-white/15 sm:h-7 sm:w-7"
          draggable="false"
        />
        <span className="whitespace-nowrap text-[11px] text-white/70 sm:text-xs">
          Developed by <span className="font-semibold text-white/95">Whitestone Defence &amp; Technology</span>
        </span>
      </div>
    </div>
  );
};
